import { Injectable } from '@angular/core'
import { ManageLoggedUser } from '../../authentication/services/manage-logged-user.service'

@Injectable({
    providedIn: 'root',
})
export class AccessService {
    constructor(private loggedUserService: ManageLoggedUser) {}

    isExternalUser() {
        return this.loggedUserService.getLoggedAccountUser().loggedUser.hub_partner_id !== 'none'
    }

    isInternalUser() {
        return this.loggedUserService.getLoggedAccountUser().loggedUser.hub_partner_id == 'none'
    }

    hasRole(roleToBeChecked: string): boolean {
        const loggedUserRoles = this.loggedUserService.getLoggedAccountUser().loggedUser.account_user_roles
        return loggedUserRoles ? loggedUserRoles.some((role: any) => role.type === roleToBeChecked) : false
    }

    hasRoles(rolesToBeChecked: string[]) {
        if (rolesToBeChecked.length == 0) {
            return true
        }

        const loggedUserRoles = this.loggedUserService.getLoggedAccountUser().loggedUser.account_user_roles
        return loggedUserRoles ? rolesToBeChecked.some(role => loggedUserRoles.some((userRole: any) => userRole.type === role)) : false
    }

    hasRoleWithValue(roleToBeChecked: string, value: string) {
        const loggedUserRoles = this.loggedUserService.getLoggedAccountUser().loggedUser.account_user_roles
        return loggedUserRoles ? loggedUserRoles.some((role: any) => role.type === roleToBeChecked && role.value.includes(value)) : false
    }

    hasRoleType(userType: string): boolean {
        const loggedUser = this.loggedUserService.getLoggedAccountUser().loggedUser
        return loggedUser ? this.loggedUserService.getLoggedAccountUser().loggedUser.account_user_role_type === userType : false
    }

    getRoleValue(roleToBeFind: string) {
        const loggedUserRoles = this.loggedUserService.getLoggedAccountUser().loggedUser.account_user_roles
        const role = loggedUserRoles ? loggedUserRoles.find((role: any) => role.type === roleToBeFind) : null
        return role ? role.value : ''
    }

    hasModule(module: string | null) {
        if (!module) return true

        const userModules = this.loggedUserService.getUserModules() as any

        if (userModules) {
            return !!userModules[module]
        }

        return false
    }
}
